export interface ContentSearchResultItem {
  generalCountryInformationId: number;
  countryId: number;
  countryName: string;
  generalCountryInformationTypeId: number;
  generalCountryInformationTypeName: string;
  snippet: string;
  modified: string;
}

export interface ContentSearchResponse {
  total: number;
  items: ContentSearchResultItem[];
}

export interface SearchSection {
  id: string;
  name: string;
  routerLink: string;
  requiresCountry: boolean;
}

export interface SearchResult {
  label: string;
  route: string;
}

export interface SearchFilterElement {
  checked: boolean;
  name: string;
  comment: string;
  class: string;
  disabled: boolean;
}

export const COUNTRY_SECTIONS: SearchSection[] = [
  {
    id: 'blacklist-information',
    name: 'Blacklist information',
    routerLink: '/country/{countryId}/general-information/1',
    requiresCountry: true,
  },
  {
    id: 'look-through-rules',
    name: 'Look through rules',
    routerLink: '/country/{countryId}/general-information/2',
    requiresCountry: true,
  },
  {
    id: 'sovereign-wealth-funds',
    name: 'Sovereign wealth funds / domestic fund regime exemptions',
    routerLink: '/country/{countryId}/general-information/3',
    requiresCountry: true,
  },
  {
    id: 'other-taxes',
    name: 'Other taxes, general considerations',
    routerLink: '/country/{countryId}/general-information/4',
    requiresCountry: true,
  },
  {
    id: 'procedures',
    name: 'Procedures',
    routerLink: '/country/{countryId}/general-information/5',
    requiresCountry: true,
  },
  {
    id: 'tax-treaties',
    name: 'Tax treaties',
    routerLink: '/country/{countryId}/general-information/6',
    requiresCountry: true,
  },
  {
    id: 'tax-rate-summaries',
    name: 'Tax rate summaries',
    routerLink: '/country/{countryId}/tax-rates-summaries',
    requiresCountry: true,
  },
  {
    id: 'tax-news',
    name: 'Tax news',
    routerLink: '/country/{countryId}/tax-news',
    requiresCountry: true,
  },
];
